<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
// 引入公共css
import '@/assets/styles/common.css'
// 引入字体图标
import '@/assets/icon/iconfont.css'
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  user-select: none;
  text-decoration: none;
  border: 0;
  outline: 0;
  box-sizing: border-box;
}
html, body {
  height: 100%;
}
#app {
  font-family: 'Microsoft YaHei';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
.header {
    background: #f8f8f8;
    line-height: 1rem;
}
.footerSty {
    width: 100%;
    background: #f8f8f8;
}
.clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: 100%;
}

.courseware-img{
  height: 2rem !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue